import { type XeroRunReason } from "@/services/xeroApi";


export const REASON_LABEL: Record<XeroRunReason, string> = {
  loaded: "Loaded",
  no_new_journals: "No new journals above the last watermark",
  daily_limit_reached: "Daily Xero call limit reached",
  token_problem: "Xero access could not be established",
  error: "Failed",
  not_selected: "Not selected for this run",
  not_attempted: "Not attempted — the run stopped early",
  in_progress: "In progress",
  not_reported: "Started but never reported",
  pending: "Waiting to start",
  not_granted: "No longer authorised in Xero",
};

const UNREMARKABLE: ReadonlySet<XeroRunReason> = new Set<XeroRunReason>([
  "loaded",
  "no_new_journals",
  "in_progress",
  "pending",
]);

export function isNoteworthy(reason: XeroRunReason | null): boolean {
  return reason !== null && !UNREMARKABLE.has(reason);
}

export const REASON_TONE: Partial<Record<XeroRunReason, string>> = {
  daily_limit_reached: "text-amber-700",
  not_attempted: "text-amber-700",
  not_granted: "text-amber-700",
  not_reported: "text-amber-700",
  token_problem: "text-destructive",
  error: "text-destructive",
};
